import { TestimonialService } from './../../api/testimonial.service';
import { Component, OnInit, Inject } from '@angular/core';
import { Testimonial } from './../../models/index';
import { OpenModalService } from './modals/open-modal.service';

@Component({
  selector: 'app-testimonials-carousel-base',
  template: ''
})

export class TestimonialsCarouselBaseComponent implements OnInit {
  autoSlideInterval: number = 10000;
  testimonials: Testimonial[] = [];
  currentSlide: number = 1;
  previousSlide: number = 0;
  nextSlide: number = 2;
  autoSlideTimer: any;

  constructor(
    private testimonialService: TestimonialService,
    private openModalService: OpenModalService,
    @Inject('WINDOW') private window: any
  ) { }

  ngOnInit(): void {
    const promise = this.testimonialService.getTestimonials();

    if (promise) {
      promise.then(testimonials => {
        this.testimonials = testimonials;
      });
    }

    if (this.window) {
      this.refreshTimer();
    }
  }

  refreshTimer(): void {
    if (this.window) {
      clearInterval(this.autoSlideTimer);
      this.autoSlideTimer = setInterval(
        () => {
          this.getNext();
        },
        this.autoSlideInterval
      );
    }
  }

  openTestimonialModal(testimonial: Testimonial): void {
    if (this.window) {
      clearInterval(this.autoSlideTimer);
    }

    const dialog = this.openModalService.showTestimonialsContent(testimonial.author, testimonial.content);
    dialog.afterClosed().subscribe(() => {

      if (this.window) {
        this.refreshTimer();
      }
    });
  }

  updateCurrentSlide(e: any, slideNumber: number): void {
    if (e.target.checked) {
      this.currentSlide = slideNumber;
      if (this.currentSlide === 0) {
        this.previousSlide = this.testimonials.length - 1;
        this.nextSlide = 1;
      } else if (this.currentSlide === this.testimonials.length - 1) {
        this.previousSlide = this.currentSlide - 1;
        this.nextSlide = 0;
      } else {
        this.previousSlide = slideNumber - 1;
        this.nextSlide = slideNumber + 1;
      }
    }
    if (this.window) {
      this.refreshTimer();
    }
  }

  getPrevious(): void {
    if (this.currentSlide === 0) {
      this.currentSlide = this.testimonials.length - 1;
      this.previousSlide = this.testimonials.length - 2;
      this.nextSlide = 0;
    } else {
      this.currentSlide--;
      if (this.previousSlide === 0) {
        this.previousSlide = this.testimonials.length - 1;
      } else {
        this.previousSlide--;
      }
      if (this.nextSlide === 0) {
        this.nextSlide = this.testimonials.length - 1;
      } else {
        this.nextSlide--;
      }
    }
    if (this.window) {
      this.refreshTimer();
    }
  }

  getNext(): void {
    if (this.currentSlide === this.testimonials.length - 1) {
      this.currentSlide = 0;
      this.previousSlide = this.testimonials.length - 1;
      this.nextSlide++;
    } else {
      this.currentSlide++;
      if (this.previousSlide === this.testimonials.length - 1) {
        this.previousSlide = 0;
      } else {
        this.previousSlide++;
      }
      if (this.nextSlide === this.testimonials.length - 1) {
        this.nextSlide = 0;
      } else {
        this.nextSlide++;
      }
    }
    if (this.window) {
      this.refreshTimer();
    }
  }

  getSlideName(slideId: number): string {
    if ( slideId === this.currentSlide) {
      return 'current-slide';
    } else if ( slideId === this.previousSlide) {
      return 'previous-slide';
    } else if ( slideId === this.nextSlide) {
      return 'next-slide';
    } else {
      return 'not-so-important-slide';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/testimonials-carousel-base.component.ts